import classNames     from 'classnames';
import * as PropTypes from 'prop-types';
import * as React     from 'react';

import useOnClickOutside from '../../../common/hooks/useOnClickOutside';

import '../../assets/scss/components/popover.scss';

const Popover = React.forwardRef((props, ref) => {
  const {
          children,
          className,
          closeTrigger,
          content,
          placement,
          trigger,
        } = props;

  const [isShown, setIsShown]     = React.useState(false);
  const [isVisible, setIsVisible] = React.useState(false);

  const popoverRef = React.useRef(null);

  const handleEnd       = React.useCallback(() => {
    setIsVisible(false);

    setTimeout(() => {
      setIsShown(false);
    }, 250);
  }, []);
  const handleStart     = React.useCallback(() => {
    setIsShown(true);

    setTimeout(() => {
      setIsVisible(true);
    }, 250);
  }, []);
  const handleClick     = React.useCallback((event) => {
    event.preventDefault();
    event.stopPropagation();

    if (!isShown) {
      handleStart();
    } else if (closeTrigger) {
      handleEnd();
    }
  }, [closeTrigger, isShown, handleEnd, handleStart]);
  const handleMouseOver = React.useCallback((event) => {
    event.preventDefault();
    event.stopPropagation();

    handleStart();
  }, [handleStart]);
  const handleMouseOut  = React.useCallback((event) => {
    event.preventDefault();
    event.stopPropagation();

    handleEnd();
  }, [handleEnd]);

  if (closeTrigger) {
    useOnClickOutside(popoverRef, () => isShown && handleEnd());
  }

  React.useImperativeHandle(ref, () => {
    return {
      handleEnd,
      handleStart,
    };
  }, [handleEnd, handleStart]);

  return (
    <>
      {React.cloneElement(children, {
        ...children.props,
        onClick(event) {
          children.props.onClick?.(event);

          if (trigger === 'click') {
            handleClick(event);
          }
        },
        onMouseOver(event) {
          children.props.onMouseOver?.(event);

          if (trigger === 'hover') {
            handleMouseOver(event);
          }
        },
        onMouseOut(event) {
          children.props.onMouseOut?.(event);

          if (trigger === 'hover') {
            handleMouseOut(event);
          }
        },
      })}
      {isShown && (
        <div
          className={classNames('popover', className, placement, {
            'show': isVisible,
          })}
          ref={popoverRef}
        >{content}</div>
      )}
    </>
  );
});

Popover.defaultProps = {
  closeTrigger: true,
  placement:    'top',
  trigger:      'hover',
};

Popover.propTypes = {
  className:    PropTypes.string,
  closeTrigger: PropTypes.bool,
  content:      PropTypes.any,
  placement:    PropTypes.oneOf(['top', 'right', 'bottom', 'left']),
  trigger:      PropTypes.oneOf(['hover', 'click']),
};

export default Popover;